import { FormControl } from "@mui/material";
import {
  LocalizationProvider,
  TimePicker,
  TimePickerProps,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";

interface GKDatePickerProps {
  inputLabel?: string;
  id?: string;
  name?: string;
  requiredField?: boolean;
  error?: boolean;
  helperText?: string;
}

const GKTimePicker = (props: GKDatePickerProps & TimePickerProps<any>) => {
  const { inputLabel, id, name, requiredField, helperText, error, ...rest } =
    props;

  return (
    <FormControl variant="standard" fullWidth sx={{ mt: 0.7 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          {...rest}
          label={inputLabel}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props?.slotProps?.textField,
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
                "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
                  borderRadius: "8px",
                },
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                  marginRight: 0,
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default GKTimePicker;
